import React from 'react'

function Skill() {
  return (
    <section id="service" class="services-mf route">          
            <div class="container">
            <div class="row">
            <div class="col-sm-12">
            <div class="title-box text-center">
            <h3 class="title-a">
             Skills
            </h3>  
            <p class="subtitle-a">
            well known tools and languages
            </p>             
            <div class="line-mf"></div>
      
             <div class="row mt-5">
            <div class="col-sm-2">
            <img src="img/mdb.webp" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">MongoDB</h5>
            </div>
            <div class="col-sm-2" >
            <img src="img/expr.jpg" class="img-fluid rounded b-shadow-a mt-.8" alt=""  />
            <h5 class="text-md ml-4 mt-3">Express JS</h5>
           </div>            
            <div class="col-sm-2">
            <img src="img/rea.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">React JS</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/nde.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Node JS</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/aws.png" class="img-fluid rounded b-shadow-a mb-.9" alt="" />
            <h5 class="text-md ml-4 mt-3">AWS</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/js.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">JavaScript</h5>
            </div>  
            </div>          
            <div class="row mt-5">
            <div class="col-sm-2">
            <img src="img/html5.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">HTML</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/cs.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">CSS</h5>
            </div>            
            <div class="col-sm-2">
            <img src="img/git.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">GitHub</h5>
            </div>
            <div class="col-sm-2 ">
            <img src="img/pst.png" class="img-fluid rounded b-shadow-a " alt="" />
            <h5 class="text-md ml-4 mt-3">Postman</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/npm.png" class="img-fluid rounded b-shadow-a " alt="" />
            <h5 class="text-md ml-4 mt-3">npm</h5>
            </div>
            <div class="col-sm-2">
            <img src="img/mys.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">MySQL</h5>
             </div>
             </div>

             <div class="row mt-5">
             <div class="col-sm-2">
            <img src="img/netlify.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Netlify</h5>
             </div>
             <div class="col-sm-2">
            <img src="img/heroku.jpg" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Heroku</h5>
             </div>
             <div class="col-sm-2">
            <img src="img/ren.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Render</h5>
             </div>
             <div class="col-sm-2">
            <img src="img/lara.jpg" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Laravel</h5>
             </div>
             <div class="col-sm-2">
            <img src="img/boot.webp" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Bootstrap</h5>
             </div>
             <div class="col-sm-2">
            <img src="img/v.png" class="img-fluid rounded b-shadow-a" alt="" />
            <h5 class="text-md ml-4 mt-3">Visual Studio</h5>
             </div>
             </div>

             
            
            </div>
            </div>
            </div>


            </div>

           

            

    </section>
    )
}

export default Skill